import {BaseContainerModel} from "../../../base-container.model";
import { bl_alg_cc_outbound_task_queue_hdr_RowClass, bl_alg_cc_outbound_task_queue_hdr_RowInterface} from "../../../../dbschema";

export class TaskQueueOutboundContainerModel extends BaseContainerModel {
    bl_alg_cc_outbound_task_queue_hdr: bl_alg_cc_outbound_task_queue_hdr_RowInterface = new bl_alg_cc_outbound_task_queue_hdr_RowClass();
}
